import React from 'react'
import {Route, Switch} from 'react-router'
import Loadable from 'react-loadable'
import Loading from './components/Loading';


const Home = Loadable({
    loader: () => import('./containers/Home'),
    loading: Loading
});

const Dashboard = Loadable({
    loader: () => import('./containers/Dashboard'),
    loading: Loading
});
const Inspections = Loadable({
    loader: () => import('./containers/Inspections'),
    loading: Loading
});
const CropProSale = Loadable({
    loader: () => import('./containers/CropProSale'),
    loading: Loading
});

const LeaseCashCrp = Loadable({
    loader: () => import('./containers/LeaseCashCrp'),
    loading: Loading
});
const PhoneBookData = Loadable({
    loader: () => import('./containers/PhoneBookData'),
    loading: Loading
});


const AddDeleteFarmsOwners = Loadable({
    loader: () => import('./containers/AddDeleteFarmsOwners'),
    loading: Loading
});

const AssetReviewWorksheets = Loadable({
    loader: () => import('./containers/AssetReviewWorksheets'),
    loading: Loading
});

const AssetReview = Loadable({
    loader: () => import('./containers/AssetReview'),
    loading: Loading
});

const ContactManagement = Loadable({
    loader: () => import('./containers/ContactManagement'),
    loading: Loading
});

const Contacts = Loadable({
    loader: () => import('./containers/Contacts'),
    loading: Loading
});

const ExistingContactGroups = Loadable({
    loader: () => import('./containers/ExistingContactGroups'),
    loading: Loading
});

const ToDoSuspenses = Loadable({
    loader: () => import('./containers/ToDoSuspenses/ToDoSuspenses'),
    loading: Loading
});
const Farms = Loadable({
    loader: () => import('./containers/Farms'),
    loading: Loading
});
const AdminUsers = Loadable({
    loader: () => import('./containers/AdminUsers'),
    loading: Loading
});

const EditContact = Loadable({
    loader: () => import('./components/EditContact'),
    loading: Loading
});

const FarmAddDeleteUpdate = Loadable({
    loader: () => import('./components/FarmsAddDeleteUpdate'),
    loading: Loading
});

const AddFarm = Loadable({
    loader: () => import('./components/AddFarm'),
    loading: Loading
});

const EditFarm = Loadable({
    loader: () => import('./components/EditFarm'),
    loading: Loading
});

const OwnersAddDeleteUpdate = Loadable({
    loader: () => import('./components/OwnersAddDeleteUpdate'),
    loading: Loading
});

const AddOwner = Loadable({
    loader: () => import('./components/AddOwner'),
    loading: Loading
});

const EditOwner = Loadable({
    loader: () => import('./components/EditOwner'),
    loading: Loading
});


const TenantsAddDeleteUpdate = Loadable({
    loader: () => import('./components/TenantsAddDeleteUpdate'),
    loading: Loading
});

const AddTenant = Loadable({
    loader: () => import('./components/AddTenant'),
    loading: Loading
});

const EditTenant = Loadable({
    loader: () => import('./components/EditTenant'),
    loading: Loading
});

const FSAOfficesAddDeleteUpdate = Loadable({
    loader: () => import('./components/FSAOfficesAddDeleteUpdate'),
    loading: Loading
});

const AddFsaOffice = Loadable({
    loader: () => import('./components/AddFsaOffice'),
    loading: Loading
});

const EditFsaOffice = Loadable({
    loader: () => import('./components/EditFsaOffice'),
    loading: Loading
});

const MVSalesAddDeleteUpdate = Loadable({
    loader: () => import('./components/MVSalesAddDeleteUpdate'),
    loading: Loading
});

const AddMarketValueSalesComparison = Loadable({
    loader: () => import('./components/AddMarketValueSalesComparison'),
    loading: Loading
});

const EditMarketValueSalesComparison = Loadable({
    loader: () => import('./components/EditMarketValueSalesComparison'),
    loading: Loading
});


const CropInsurancePricesAddDeleteUpdate = Loadable({
    loader: () => import('./components/CropInsurancePricesAddDeleteUpdate'),
    loading: Loading
});

const AddPhoneBookData = Loadable({
    loader: () => import('./components/AddPhoneBookData'),
    loading: Loading
});
const EditPhoneData = Loadable({
    loader: () => import('./components/EditPhoneData'),
    loading: Loading
});
const ForgotPassword = Loadable({
    loader: () => import('./components/ForgotPassword'),
    loading: Loading
});

const MassMessage = Loadable({
    loader: () => import('./containers/MassMessages'),
    loading: Loading
});

const ContactReport = Loadable({
    loader: () => import('./containers/ContactReports'),
    loading: Loading
});

const OwnerInfoReport = Loadable({
    loader: () => import('./containers/OwnerInfoReports'),
    loading: Loading
});

const TenantInfoReport = Loadable({
    loader: () => import('./containers/TenantInfoReports'),
    loading: Loading
});

const UpdatePassword = Loadable({
    loader: () => import('./components/UpdatePassword'),
    loading: Loading
});

const routes = (
    <Switch>
        <Route exact path="/" component={Home}/>
        <Route path="/account/dashboard" component={Dashboard}/>
        <Route path="/asset-review-worksheets" component={AssetReviewWorksheets}/>
        <Route path="/asset-review" component={AssetReview}/>
        <Route path="/contact-management" component={ContactManagement}/>
        <Route path="/new-contact" component={Contacts}/>
        <Route path="/existing-contact-groups" component={ExistingContactGroups}/>
        <Route path="/to-do-suspenses" component={ToDoSuspenses}/>
	    <Route path="/inspections" component={Inspections}/>
        <Route path="/cropProSale" component={CropProSale}/>
        <Route path="/leaseCashCrp" component={LeaseCashCrp}/>
        <Route path="/phone-book-data" component={PhoneBookData}/>
        <Route path="/add-delete-farm-owners" component={AddDeleteFarmsOwners}/>
        <Route path="/farms/" component={Farms}/>
        <Route path="/account/admin/users" component={AdminUsers}/>
        <Route path="/contact/edit-contact/:id" component={EditContact}/>
        <Route path="/farm" component={FarmAddDeleteUpdate}/>
        <Route path="/add-farm" component={AddFarm}/>
        <Route path="/edit-farm/:id" component={EditFarm}/>
        <Route path="/owner" component={OwnersAddDeleteUpdate}/>
        <Route path="/add-owner" component={AddOwner}/>
        <Route path="/edit-owner/:id" component={EditOwner}/>
        <Route path="/tenant" component={TenantsAddDeleteUpdate}/>
        <Route path="/add-tenant" component={AddTenant}/>
        <Route path="/edit-tenant/:id" component={EditTenant}/>
        <Route path="/fsa-offices" component={FSAOfficesAddDeleteUpdate}/>
        <Route path="/add-fsa-office" component={AddFsaOffice}/>
        <Route path="/edit-fsaOffice/:id" component={EditFsaOffice}/>
        <Route path="/mv-sales-comparisons" component={MVSalesAddDeleteUpdate}/>
        <Route path="/add-mv-sales-comparison" component={AddMarketValueSalesComparison}/>
        <Route path="/edit-mv-sales-comparison/:id" component={EditMarketValueSalesComparison}/>
        <Route path="/crop-insurance-prices" component={CropInsurancePricesAddDeleteUpdate}/>
        <Route path="/add-phone-book-data" component={AddPhoneBookData}/>
        <Route path="/edit-phone-book-data/:id" component={EditPhoneData}/>
        <Route path="/forgot-password" component={ForgotPassword}/>
        <Route path="/mass-messages" component={MassMessage} />
        <Route path="/contact-report" component={ContactReport} />
        <Route path="/owner-information-report" component={OwnerInfoReport} />
        <Route path="/tenant-information-report" component={TenantInfoReport} />
        <Route path="/update-password" component={UpdatePassword}/>
    </Switch>
);

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js